
import React, { useState, useEffect, useContext, useRef } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import LocationSearch from "./LocationSearch";
import { keyActivate } from "../utils/a11y";
import { validateBusinessAddress, validateName } from "../utils/textQuality";



let { lambda, country, appname } = window.app;

const TERMS_URL = "https://myspotsaver.com/terms-of-use.html";
const PRIVACY_URL = "https://myspotsaver.com/privacy-policy.html";
const TERMS_ERROR = "Please agree to the Terms and Conditions and Privacy Policy";

const PILOT_PLAN_NAME = "60-Day Pro Pilot";
const PILOT_PLAN_TAGLINE = "Try SpotSaver Pro free for 60 days, with live queue management, paid spots, analytics, and support.";
// Plan limits are stored under the backend's role names; show the Pro App's.
const FEATURE_NAMES = {
    "Store": ["Location", "Locations"],
    "Brand Manager": ["Brand Manager", "Brand Managers"],
    "Store Manager": ["Location Manager", "Location Managers"],
    "Security Officer": ["Security Staff", "Security Staff"],
};
// Free-text plan features whose stored wording no longer fits the product.
const FEATURE_TEXT = {
    "Unlimited Calendars": "Three Free or Paid Queues",
    "Stripe Payment Support": "Secure Payments and Payouts",
};

const SignUp = () => {
    const [pwd, setPwd] = useState('');
    const [email, setEmail] = useState("");
    let signUpData = JSON.parse(localStorage.getItem("signup"))
    const [formData, setFormData] = useState({ businessname: signUpData?.businessname || "", phone: signUpData?.phone || "", emailId: signUpData?.emailId || "", logo: signUpData?.logo || [], idc: signUpData?.idc || "", contactname: signUpData?.contactname || "", businessaddress: signUpData?.businessaddress || "" });
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [subscriptionsData, setSubscriptionsData] = useState([]);

    const [image, setImg] = useState(process.env.REACT_APP_IMAGE_CLOUD_FRONT);
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [showSessionPopup, setShowSessionPopup] = useState(false);
    const [BtnLoader, setBtnLoader] = useState(false);

    const { setUserData, clientInfo, GetUserDataContext, activeMenuId, setActiveMenuId, mapsAPIkey } = useContext(contentContext)
    const [address, setAddress] = useState('');
    const [suggestions, setSuggestions] = useState([]);

    const [exist, setExist] = useState(false)
    const [sendEmail, setSendEmail] = useState(false)
    const [alertMsg, setAlertMsg] = useState(false)
    const [activeButtons, setActiveButtons] = useState({});
    const [verifyLoader, setVerifyLoader] = useState(false)
    const [countries, setCountries] = useState('');
    const [autocomplete, setAutocomplete] = useState(null);
    const inputRef = useRef(null); // Ref for the input element
    // console.log('google.maps.places',window.google.maps.places.Autocomplete); 

    // Ref for the search box
    // console.log('window.config',window?.site);
    const searchBoxRef = useRef(null);
    const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState({});
    const [selectedPlace, setSelectedPlace] = useState(signUpData?.addressData || '');
    const [addressData, setAddressData] = useState(signUpData?.addressData || {});
    const [filesData, setFilesData] = useState([]);
    const [files, setFiles] = useState([]);
    const [termsAccepted, setTermsAccepted] = useState(false);

    //  const [mapsAPIkey, setMapsAPIkey] = useState({});
    // const [idc, setIdc] = useState("US(+1)");
    console.log('selectedPlace', selectedPlace)
    console.log('addressData', addressData)
    // let siteConfig = window?.site?.common;
    // let appResourcesUrl = siteConfig?.imageCloudfront;

    // useEffect(() => {
    //     const defaultButtons = {};
    //     subscriptionsData.forEach((plan) => {
    //       defaultButtons[plan.planid] = 'Monthly';
    //     });
    //     setActiveButtons(defaultButtons);
    //   }, [subscriptionsData]);

    useEffect(() => {

        if (selectedPlace) {
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                ['businessaddress']: selectedPlace, // Update the changed field
            }));
        }


    }, [selectedPlace]);
    useEffect(() => {
        console.log("window.site---->", window.site);

        if (window?.site === undefined) {
            setTimeout(() => {
                if (window?.site?.common?.google?.mapsAPIkey) {

                    // setMapsAPIkey(window?.site?.common?.google?.mapsAPIkey)
                    // setImg(window.site.common.imagesCDN)
                    console.log('window.site', window.site)
                }
            }, 1000);
        }
        if (window?.site?.common?.google?.mapsAPIkey) {
            //setMapsAPIkey(window?.site?.common?.google?.mapsAPIkey)
        }

    }, [window.site]);


    // useEffect(() => {
    //     const poll = (tries = 0) => {
    //       const cf = window?.site?.common?.imageCloudfront;
    //       if (cf || tries > 50) return cf && setImg(cf);   // 50 × 20 ms ≈ 1 s cap
    //       setTimeout(() => poll(tries + 1), 20);
    //     };
    //     poll();                                           // start once
    //   }, []);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);
    useEffect(() => {
        if (toastMessage) {
            toast.warning(toastMessage, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);
    const handleAddressChange = (addressData) => {
        setFormData((prevState) => ({
            ...prevState,
            businessaddress: addressData?.fullAddress || "",
        }));

        setError((prevError) => ({
            ...prevError,
            businessaddress: "",
        }));
    };
    const handleSelectPlan = (plan) => {
        const selectedPlanType = activeButtons[plan.planid];  // Get the active plan type for the selected plan

        const updatedSelectedPlan = {
            ...plan,
            planType: selectedPlanType  // Include the plan type in the selected plan object
        };
        setSelectedPlan(updatedSelectedPlan);
        console.log('selected plan', updatedSelectedPlan)
    };
    console.log('formdata', formData)
    // Initialize Google Places Autocomplete



    const getSbscriptionsApi = (e) => {
        axios({
            method: 'GET',
            url: `${lambda}/getSubscriptions?appname=${appname}`,
        })
            .then((response) => {
                if (response?.data?.result === "Invalid token or Expired") {
                    // setShowSessionPopupup(true)
                } else {
                    const data = response?.data?.result;

                    if (data) {
                        // Setting the subscriptions data
                        setSubscriptionsData(data);

                        // Creating default buttons with 'Monthly' as default value
                        const defaultButtons = {};
                        data.forEach((plan) => {
                            defaultButtons[plan.planid] = 'Monthly';
                        });
                        setActiveButtons(defaultButtons);

                        // Checking the status of all plans dynamically
                        const activePlans = data.filter(plan => plan.status === 'ACTIVE');
                        let selectedPlanData;

                        // Handle conditions based on active plans count
                        if (activePlans.length >= 3) {
                            // If three or more plans are active, select the FIRST one
                            selectedPlanData = activePlans[0];
                        } else if (activePlans.length === 2) {
                            // If two plans are active, select the FIRST one
                            selectedPlanData = activePlans[0];
                        } else if (activePlans.length === 1) {
                            // If only one plan is active, select that plan
                            selectedPlanData = activePlans[0];
                        } else {
                            // If no plans are active, select the first plan by default
                            selectedPlanData = data[0];
                        }


                        if (selectedPlanData) {
                            const selectedPlanType = defaultButtons[selectedPlanData.planid] || 'Monthly';

                            const updatedSelectedPlan = {
                                ...selectedPlanData,
                                planType: selectedPlanType
                            };

                            setSelectedPlan(updatedSelectedPlan);
                        }
                    }

                }
            })
            .catch((err) => {
                console.log('Error:', err);
            });
    }


    // console.log('sudata',subscriptionsData);


    // useEffect(() => {
    //     websitedefaults();
    // }, []);
    // const websitedefaults = async () => {
    //     try {
    //         console.log(tmdbApi);
    //         const response = await tmdbApi.websitedefaults();

    //         console.log(response);
    //     } catch {
    //         console.log("error");
    //     }
    // };


    //  useEffect(() => {
    //      if ((localStorage.getItem("userId"))) {
    //          GetUserDataSignIn();
    //      }
    //  }, []);

    useEffect(() => {
        if (localStorage.getItem("token") && clientInfo?.subscriptionPayment === "PAYMENT SUCCESS") {
            // navigate("/dashboard");
            navigate("/locations")
        }
        getSbscriptionsApi();
        GetCountries()
    }, []);

    // const handleKeypress = (e) => {
    //     //it triggers by pressing the enter key

    //     if ((e.key === "Enter")) {
    //         setTimeout(function () {
    //             //  handleSignIn();
    //             console.log("called");
    //         }, 1000);
    //     }
    // };
    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });

            const countries = response?.result?.data || [];
            setCountries(countries);
            const usaCountry = countries.filter(
                eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
            );

            // Print the filtered country in the console
            console.log("USA Country:", usaCountry);
            setFormData({ ...formData, idc: usaCountry?.[0]?.alpha3 })
            // console.log('responseresponseresponse',response?.result.data)
            // await axios({
            //     method: 'GET',
            //     url: "https://d4nv8o5tzs3mt.cloudfront.net/",
            // })
            //     .then(function (response2) {
            //         console.log('response2',response2)
            //       // let locData = JSON.stringify(response?.data)
            //       let temp = response2.data.headers['cloudfront-viewer-country'][0].value
            //       console.log('temp',temp)
            //       setDefaultCountryCode(temp)

            //       let k = response && response?.result && response?.result.data && response?.result.data.length>0 && response?.result.data.filter(eachItem=>eachItem.alpha2.trim()===temp)

            //       if (id===undefined) {
            //         setIdc(k[0].alpha3)
            //         let newUser = Object.assign({}, editUser);
            //         setEditUser({ ...newUser, ['idc']: k[0].alpha3 });
            //       }



            //     });

        } catch {
            console.log("error");
        }
    };



    const handleSignUp = async (filesData) => {

        let logoImage = filesData?.[0]?.filepath;
        // console.log("ppan",selectedPlan)
        // let plan = selectedPlan.split(" ");
        // console.log("plan",plan)
        //  let planName = plan && plan[0] &&plan[0].toUpperCase();
        formData["subscription"] = selectedPlan?.planname
        formData["subscriptionPrice"] = selectedPlan?.planType == "Monthly" ? selectedPlan?.monthly : selectedPlan?.yearly
        formData["plantype"] = selectedPlan?.planType
        formData["planid"] = selectedPlan?.planType == "Monthly" ? selectedPlan?.monthly_planid : selectedPlan?.yearly_planid

        // Keep the typed address when nothing was resolved through Google.
        formData["businessaddress"] = addressData?.fullAddress || formData?.businessaddress || ""
        localStorage.setItem("signup", JSON.stringify(formData))
        //console.log("formDataformDataformData",formData)
        try {

            // The backend refuses a sign-up without termsAccepted and records when
            // and to which Terms/Privacy versions it was given.
            const response = await tmdbApi.AddClient({
                ...formData, logo: filesData?.length > 0 ? logoImage : "", termsAccepted
            });
            console.log(response);
            if (response?.result === "Client Already Exists") {
                setBtnLoader(false)
                setToastMessage("Business Already Exists")
                //    AddNotify()

            } else if (response?.result === "There is an account with this phone number") {
                setToastMessage("There is an account with this phone number")
                setBtnLoader(false)
            } else if (response?.result === "Terms Not Accepted") {
                setBtnLoader(false)
                setError((prevData) => ({ ...prevData, terms: TERMS_ERROR }))
            } else if (response?.result === "PENDING VERIFICATION") {
                setBtnLoader(false)

                setSendEmail(true)
            } else if (response?.result === "PENDING APPROVAL") {
                setBtnLoader(false)
                localStorage.setItem("signup", null)
                //    setAlertMsg(true)
                navigate("/thankyou")
            } else if (response.result === "The account has been archived") {
                setBtnLoader(false)
                setToastMessage("The account has been archived");
                // setTimeout(() => {
                //   setError("");  // Clears the error after 3 seconds
                // }, 3000);
            } else {
                setBtnLoader(false)
                localStorage.setItem("signup", null)
                navigate("/verifyaccount")
            }
        } catch {
            console.log("error");
            setBtnLoader(false)
            setError("Invalid email or password");
            setTimeout(function () { setError("") }, 3000);
        }
    };
    // console.log('userDatauserDatauserData', userData)
    const GetUserDataSignIn = async () => {
        try {

            const response = await tmdbApi.getUserData({});

            if (response?.statusCode === 200) {

                setUserData(response?.result?.[0]);
                localStorage.setItem("ClientName", response?.result?.[0]?.name)
                localStorage.setItem("ClientType", response?.result?.[0]?.type)
                let userArr = response?.result?.[0]?.permissions
                const EMAILID = response?.result?.[0]?.emailid
                console.log('user email', EMAILID)
                window.clarity("set", "orasi_user_email", EMAILID)
                // Clarity.addTag('Orasi User Email', EMAILID);
                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // console.log('objjjjjjjj--->',obj)

                if (!(localStorage.getItem("check"))) {
                    let k = response?.result?.[0]

                    let permissionList = response && response?.result && response?.result?.[0] && response?.result?.[0]?.permissions
                    let filterdList = permissionList.filter((item) => item.display === true)
                    const data = filterdList?.filter((value) => value?.menu === "Dashboard")
                    let id = data && data[0] && data[0].menu.split(" ").join("").toLowerCase()

                    navigate("/" + id);
                    navigate("/usermanagement");


                    setActiveMenuId(data && data[0] && data[0].menuid)
                    console.log("activeMenuid------->", data)
                }

                // setActiveMenuObj(obj)
                // setBtnLoader("")
                // console.log('response?.result?.[0] kkkkkkkkkk', response?.result?.[0])
            }
        } catch {
            // setBtnLoader("")
            console.log("error");
        }
    };
    // const AddNotify = () => {
    //     toast.warning(toastMessage, {
    //         position: "bottom-center",
    //       autoClose: 3000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   };
    // const forgotPassword = async () => {
    //     try {
    //         setBtnLoader("forgotpwd")
    //         const response = await tmdbApi.ForgotPassword({
    //             "emailid": email
    //         });
    //         console.log(response);
    //         if (response?.statusCode===200 && response?.result === "mail sent successfully") {
    //             setSuccess(true);
    //         } else if (response?.statusCode===200 && response?.result === "Email does not exists") {
    //             setError("Email Does Not Exists . Please Enter Valid Email");
    //             setTimeout(function () { setError("") }, 3000);
    //         } else {
    //             setError("Please Enter Email Id");
    //             setTimeout(function () { setError("") }, 3000);
    //         }
    //         setBtnLoader("")
    //     } catch {
    //         console.log("error");
    //         setBtnLoader("")
    //         setError("Please enter email id");
    //         setTimeout(function () { setError("") }, 3000);
    //     }
    // };


    // const handleForgot = (e) => {
    //     if (BtnLoader==="") {
    //         // forgotPassword();
    //     }
    // }

    // function onConfirm() {
    //     setSuccess(false);
    // };

    // const handleShowSessionPopup = () => {
    //     setShowSessionPopup(true)
    // }
    const onCancel = () => {
        setShowSessionPopup(false)
        // setBtnLoader("")
    }
    const signoutsession = async () => {
        try {
            // setBtnLoader("sessionLoad")
            const response = await tmdbApi.SignOutUser({ emailId: email });
            console.log(response);
            if (response?.result === "Success") {
                //  loginPwd()
            } else {
                setError("Invalid Details");
                // setBtnLoader("")
            }
        } catch {
            // setBtnLoader("")
            console.log("error");
        }
    }

    // const handleMessage = (e) => {
    //     setError("");
    // }


    const handleVerify = () => {



        handleUploadSubmit()



    }
    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state

        setFormData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));

    };
    const handleChange = (event) => {
        const { name, value } = event.target;

        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = formData?.idc?.trim(); // Directly get the latest idc value

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
            setError({ ...error, phone: "" })
            // Update the phone number only
            setFormData(prev => ({ ...prev, [name]: formattedValue }));

        } else if (name === "contactname") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, contactname: "" })

        } else if (name === "businessname") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, businessname: "" })

        } else if (name === "emailId") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, emailId: "" })

        } else {
            // Allow normal updates for other fields
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the changed field
            }));
        }
    };
    const handleSend = async () => {
        setVerifyLoader(true);
        try {
            const response = await tmdbApi.resendMail({
                emailId: formData?.emailId,
            });
            console.log(response);
            navigate("/verifyaccount");
            setSendEmail(false);
        } catch (error) {
            console.error("Error in handleSend:", error); // Logs the actual error
            setSendEmail(false);
        } finally {
            setVerifyLoader(false); // Ensure this is always reset
        }
    };

    const handleRemove = () => {
        // setUploadImg("")
        //setFormData("")
        setFilesData([])
        setFormData(prev => ({
            ...prev,
            logo: [] // Clear the logo array
        }));
    }
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        // const selectedFilesSize = selectedFile.size; //for single file
        const selectedFiles = Array.from(event.target.files);  //for multiple files
        // const selectedFilesSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);  //for multiple files
        // console.log("selectedFile ", selectedFile)
        // console.log("selectedFiles ", selectedFiles)
        const allowedFileTypes = ["image/jpeg", "image/png", "image/heic"];
        let fileSize = 1048612 * 5 // 5MB
        if (selectedFile && !allowedFileTypes.includes(selectedFile.type)) {
            setToastMessage("Only JPG, PNG, and HEIC files are allowed!");
            event.target.value = null;
            return;
        } else

            if (selectedFile.size < fileSize) {
                const previewUrl = URL.createObjectURL(selectedFile);
                setFormData(prev => ({
                    ...prev,
                    logo: [{ filepath: previewUrl }]
                }));
                setFilesData([selectedFile]); // Store file data

            } else {
                setToastMessage("File size should not exceed 5MB"); // Set the error message
                event.target.value = null;

            }




        // setFiles([...files, ...selectedFiles]); //for multiple files




    };
    const handleUploadSubmit = async () => {

        const ObjectID = require("bson-objectid");
        const uniqueId = new ObjectID().toString();
        // setLocationId(locationId)
        const validate = handleValidations()
        if (validate) {
            setBtnLoader(true)
            localStorage.setItem("emailid", formData?.emailId);
            localStorage.setItem("phone", formData?.phone);

            if (filesData && filesData?.length > 0) {

                const uploadPromises = Array.from(filesData).map(async (file) => {
                    const timestamp = Date.now();
                    const fileExtension = file?.name?.split('.').pop();
                    const clientid = localStorage.getItem('userId');
                    const token = localStorage.getItem('token');
                    const ObjectID = require("bson-objectid");

                    const uniqueId = new ObjectID().toString();
                    let uploadFilePath;
                    let bucket;

                    // Check the file type
                    if (file.type.startsWith('image/')) {
                        // File is an image
                        let filenameReplace = file.name.replace(/ /g, "_")
                        uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                        bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                        const data = {
                            source_bucket: bucket, // Use the correct bucket based on file type
                            sourcepath: uploadFilePath
                        };
                        console.log("data", data)
                        const newFile = [{
                            filename: filenameReplace.split('.')[0],
                            filepath: uploadFilePath,
                            fileid: uniqueId,
                            filetype: file.type,
                            filesize: file.size,
                            fileformat: fileExtension
                        }]
                        const updatedFiles = [...files, ...newFile];
                        console.log("updatedFiles", updatedFiles)
                        setFiles(updatedFiles);

                        const uploadPromise = axios.post(
                            `${lambda}/uploadURL?appname=${appname}`,
                            data,
                            { headers: { 'Content-Type': 'application/json' } }
                        ).then(async uploadUrlResponse => {
                            if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                                const url = uploadUrlResponse.data.result;

                                return axios.put(url, file, {
                                    headers: {
                                        'Content-Type': file.type,
                                        'Cache-Control': 'no-cache'
                                    }
                                }).then(async uploadResponse => {
                                    if (uploadResponse.status === 200) {
                                        // setFiles([...files, ...newFile]); 
                                        // handleSubmit(updatedFiles);
                                        handleSignUp(updatedFiles)
                                    } else {
                                        throw new Error('Failed to upload file to S3');
                                    }
                                });
                            } else {
                                throw new Error('Failed to get upload URL');
                            }
                        });


                    }


                });

                try {
                    //const results = await Promise.all(uploadPromises);
                    await Promise.all(uploadPromises);

                } catch (error) {
                    console.error('Error during file upload:', error);
                }
            } else {
                // handleSubmit([], uniqueId);

                handleSignUp([]);

            }
        }


    }
    console.log("selectedPlaannnnnnnnnnnnnnnnnnnn", selectedPlan)
    const handleClose = () => {
        setSendEmail(false)
    }
    const handleValidations = () => {
        let formIsValid = true;
        const businessnameError = formData?.businessname === ""
            ? "Please enter name"
            : validateName(formData?.businessname, "business name");
        if (businessnameError) formIsValid = false;
        setError((prevData) => ({
            ...prevData,
            ["businessname"]: businessnameError,
        }));

        const contactnameError = validateName(formData?.contactname, "contact name");
        if (contactnameError) formIsValid = false;
        setError((prevData) => ({
            ...prevData,
            ["contactname"]: contactnameError,
        }));

        // The address can be hand-typed when Google Places is down, so it gets
        // the same junk / profanity screening as a suggested one.
        const businessaddressError = validateBusinessAddress(
            addressData?.fullAddress || formData?.businessaddress
        );
        if (businessaddressError) formIsValid = false;
        setError((prevData) => ({
            ...prevData,
            ["businessaddress"]: businessaddressError,
        }));
        if (formData?.phone === "") {
            setError((prevData) => ({
                ...prevData,
                ["phone"]: "Please enter phone number",
            }));


            formIsValid = false;
        } else if (
            (formData.idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.phone)) ||
            (formData.idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(formData.phone))
        ) {
            setError((prevData) => ({
                ...prevData,
                ["phone"]: 'Invalid phone number format',
            }));

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["phone"]: "",
            }));
        }


        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (formData?.emailId === "") {
            setError((prevData) => ({
                ...prevData,
                emailId: "Please enter Email",
            }));
            formIsValid = false;
        } else if (!emailRegex.test(formData?.emailId)) {
            setError((prevData) => ({
                ...prevData,
                emailId: "Please enter a valid Email address",
            }));
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                emailId: "",
            }));
        }

        const termsError = termsAccepted ? "" : TERMS_ERROR;
        if (termsError) formIsValid = false;
        setError((prevData) => ({
            ...prevData,
            terms: termsError,
        }));

        return formIsValid;
    }
    // One Monthly/Yearly toggle drives every plan, so the billing period stays
    // the same while the user compares plans and switches between them.
    const handleBillingChange = (type) => {
        setActiveButtons(Object.fromEntries(subscriptionsData.map((plan) => [plan.planid, type])));
        setSelectedPlan(prevPlan => ({
            ...prevPlan,
            planType: type
        }));
    };

    console.log("contactttttttttttttttttttttttttttttttttttttttttnameeee", formData)

    // With only one active plan there is nothing to choose (getSbscriptionsApi
    // already auto-selects it), so it is shown as a summary instead of a picker.
    const activePlans = subscriptionsData.filter((plan) => plan.status === 'ACTIVE');
    const singlePlan = activePlans.length === 1 ? activePlans[0] : null;
    const isFreePlan = (plan) => !Number(plan?.monthly) && !Number(plan?.yearly);
    // The free plan is offered as the 60-day Pro pilot. Only the wording shown
    // here changes: the backend matches plans by planname and reads user limits
    // from the stored feature names, so the plan data keeps its original names.
    const planName = (plan) => isFreePlan(plan) ? PILOT_PLAN_NAME : plan.planname;
    const planTagline = (plan) => isFreePlan(plan) ? PILOT_PLAN_TAGLINE : plan.tagline;
    const featureText = (feature) => {
        if (!feature.label) return FEATURE_TEXT[String(feature.value).trim()] || feature.value;
        const [one, many] = FEATURE_NAMES[feature.feature] || [feature.feature, `${feature.feature}s`];
        return `${feature.value} ${Number(feature.value) === 1 ? one : many}`;
    };
    const isSelectedPlan = (plan) => selectedPlan?.planname?.toLowerCase() === plan.planname?.toLowerCase();
    const billingType = activeButtons[activePlans[0]?.planid] || 'Monthly';
    const formatPrice = (value) => {
        const price = Number(value) || 0;
        return `$${Number.isInteger(price) ? price : price.toFixed(2)}`;
    };
    // Actual discount of the yearly price over 12 monthly payments, taken from
    // the plan data rather than a fixed figure; 0 when yearly is not cheaper.
    const yearlySavings = (plan) => {
        const twelveMonths = Number(plan?.monthly) * 12;
        return twelveMonths > 0 ? Math.max(0, Math.floor((1 - Number(plan?.yearly) / twelveMonths) * 100)) : 0;
    };
    // The toggle covers every plan, so it only claims a flat "save X%" when all
    // paid plans save exactly that; otherwise it is "up to" the best one.
    const savings = activePlans.filter((plan) => !isFreePlan(plan)).map(yearlySavings);
    const bestSaving = Math.max(0, ...savings);
    const savingsLabel = bestSaving ? `Save ${savings.every((saving) => saving === bestSaving) ? '' : 'up to '}${bestSaving}%` : '';

    const renderPlanPrice = (plan) => (
        isFreePlan(plan) ? (
            <><span>Free</span> for 60 days</>
        ) : (
            <>
                <span>{formatPrice(billingType === 'Yearly' ? plan.yearly : plan.monthly)}</span>
                {billingType === 'Yearly' ? ' /year' : ' /month'}
            </>
        )
    );

    // Free plans have nothing to bill, so the toggle only shows when a paid plan is on offer.
    const billingToggle = activePlans.some((plan) => !isFreePlan(plan)) && (
        <div className="select_billing" id="plan-billing-toggle">
            <button
                className={`yearly ${billingType === 'Monthly' ? 'active' : ''}`}
                onClick={() => handleBillingChange('Monthly')}
            >
                Monthly
            </button>
            <button
                className={`yearly ${billingType === 'Yearly' ? 'active' : ''}`}
                onClick={() => handleBillingChange('Yearly')}
            >
                Yearly {savingsLabel && <span className="billing_save_badge">{savingsLabel}</span>}
            </button>
        </div>
    );


    return (
        <>
            <Modal className="access-denied" show={showSessionPopup}>
                <div className="modal-body enquiry-form" id="session-modal-body">
                    <div className="container" id="session-container">

                        <button
                            className="close-btn"
                            id="session-close-button"
                            onClick={e => onCancel()}
                        >
                            <span className="material-icons">close</span>
                        </button>

                        <span className="material-icons access-denied-icon" id="session-icon">
                            web_asset_off
                        </span>

                        <h3 id="session-heading">Multiple Sessions Found</h3>
                        <p id="session-description">
                            Another session is running in another browser. Do you want to terminate that session?
                        </p>

                        <div className="popup-footer" id="session-footer">
                            <button
                                className="fill_btn yellow-gradient"
                                id="session-yes-button"
                                data-bs-toggle="modal"
                                data-bs-target="#recommendModal"
                                onClick={e => signoutsession()}
                            >
                                Yes
                            </button>

                            <button
                                className="fill_btn"
                                id="session-no-button"
                                data-bs-toggle="modal"
                                data-bs-target="#recommendModal"
                                onClick={e => onCancel()}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>


            <div className="signin-wrapper registration" id="signin-wrapper">
                <div className="logo_section" id="logo-section">
                    <img
                        src={`${image}${appname}/images/web/logo-dark.png`}
                        className="logo"
                        id="logo"
                    />
                    <button className="close-btn" id="close-btn" onClick={() => {
                        window.location.href = 'https://d1fln26yclkehg.cloudfront.net/index.html';
                    }}>
                        <span
                            className="material-icons"

                            id="close-icon"
                        >
                            close
                        </span>
                    </button>

                </div>
                <div className="card" id="create-client-card">
                    <div className="card-body" id="create-client-card-body">
                        <div className="create_client" id="create-client">
                            <div className="d-flex flex-column" id="steps-title">

                                <h1 className="bold-heading" id="create-client-title">Become a SpotSaver Pro</h1>
                                <h5 id="create-client-subtitle">Let’s get your business set up in a few quick steps.</h5>
                                <p className="signup-prompt mt-3 login-have-txt" id="defaultCreateAccountPrompt">
                                    Already have an account?
                                    <a className="mx-2" style={{ cursor: 'pointer' }} onClick={() => { navigate('/signin') }} onKeyDown={keyActivate(() => { navigate('/signin') })} id="defaultCreateAccountLink">
                                        Log In
                                    </a>
                                </p>
                            </div>

                            {/* <div className="steps" id="steps">
          <p id="step-count"><span>1</span>/2</p>
          <div className="d-flex flex-row" id="step-buttons">
            <button className="step_btn active" id="active-step-btn"></button>
            <button className="step_btn" id="inactive-step-btn"></button>
          </div>
        </div> */}
                        </div>
                        {singlePlan ? (
                            <div className="plans single_plan" id="plans-row">
                                <div className="single_plan_head">
                                    <div className="single_plan_title">
                                        <span className="single_plan_eyebrow">Your plan</span>
                                        <h6 id={`plan-name-${singlePlan.planname?.toLowerCase()}`}>{planName(singlePlan)}</h6>
                                        {planTagline(singlePlan) && (
                                            <p id={`plan-tagline-${singlePlan.planname?.toLowerCase()}`}>{planTagline(singlePlan)}</p>
                                        )}
                                    </div>
                                    <p className="single_plan_price" id={`plan-price-${singlePlan.planname?.toLowerCase()}`}>
                                        {renderPlanPrice(singlePlan)}
                                    </p>
                                </div>

                                {billingToggle}

                                <ul className="single_plan_features">
                                    {singlePlan.features?.filter((feature) => feature.value).map((feature, index) => (
                                        <li key={index} id={`feature-${index}-${singlePlan.planname?.toLowerCase()}`}>
                                            <span className="material-symbols-outlined">check_circle</span>
                                            {featureText(feature)}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : (
                            <>
                                <div className="plans plan_picker_head">
                                    <div className="select_plan" id="select-plan">
                                        <div className="icon" id="plan-icon">
                                            <img src={`${image}${appname}/images/web/cards.svg`} id="plan-img" />
                                        </div>
                                        <div className="text" id="plan-text">
                                            <h6 id="select-plan-title">Select Plan</h6>
                                            <p id="plan-description">Choose the plan that fits your brand</p>
                                        </div>
                                    </div>
                                    {billingToggle}
                                </div>

                                <div className="row plans" id="plans-row">
                                    {activePlans.map((plan) => (

                                        <div key={plan.planid} className={activePlans.length === 2 ? 'col-md-6' : 'col-md-4'} id={`plan-col-${plan.planid}`}>
                                            <div
                                                className={`basic_plan ${isSelectedPlan(plan) ? 'active_plan' : ''}`}
                                                id={`plan-${plan.planname?.toLowerCase()}`}
                                            >
                                                <h6 id={`plan-name-${plan.planname?.toLowerCase()}`}>{planName(plan)}</h6>
                                                <p className="per_month" id={`plan-price-${plan.planname?.toLowerCase()}`}>
                                                    {renderPlanPrice(plan)}
                                                    {billingType === 'Yearly' && yearlySavings(plan) > 0 && (
                                                        <span className="plan_save_badge" id={`plan-savings-${plan.planname?.toLowerCase()}`}>
                                                            Save {yearlySavings(plan)}%
                                                        </span>
                                                    )}
                                                </p>
                                                <p id={`plan-tagline-${plan.planname?.toLowerCase()}`}>{planTagline(plan)}</p>

                                                {/* <button
                      className="fill-btn black_btn"
                      onClick={() => handleSelectPlan(plan)}
                      id={`plan-select-btn-${plan.planname?.toLowerCase()}`}
                    >
                      Select
                    </button> */}

                                                <hr id={`plan-hr-${plan.planname?.toLowerCase()}`} />

                                                {plan.features.map((feature, index) => (
                                                    feature.value && (
                                                        <div key={index} className="points" id={`feature-${index}-${plan.planname?.toLowerCase()}`}>
                                                            <span className="material-symbols-outlined check-icons">chevron_right</span>
                                                            <p id={`feature-description-${index}-${plan.planname?.toLowerCase()}`}>
                                                                {featureText(feature)}
                                                            </p>
                                                        </div>
                                                    )
                                                ))}
                                                <div className="Plan-select-footer">
                                                    <button className={`fill-btn ${isSelectedPlan(plan) ? "" : "black_btn"}`}
                                                        onClick={() => handleSelectPlan(plan)}
                                                        id={`plan-select-btn-${plan.planname?.toLowerCase()}`}
                                                    >
                                                        {isSelectedPlan(plan) ? (
                                                            <><span className="material-symbols-outlined plan_selected_icon">check</span>Selected</>
                                                        ) : 'Select'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="card client_details client-details-errormssg" id="client-details-card">
                    <div className="card-body" id="client-details-card-body">
                        <div className="row" id="client-details-row">
                            <div className="col-md-12 client-details-section error" id="client-details-col-1">
                                <div className="select_plan" id="client-details-select-plan">
                                    <div className="icon" id="client-details-icon">
                                        <img
                                            src={`${image}${appname}/images/web/user-profile.svg`}
                                            id="client-profile-icon"
                                        />
                                    </div>
                                    <div className="text" id="client-details-text">
                                        <h6 id="client-details-title">Business Details</h6>
                                        <p id="client-details-description">Tell us about your business.</p>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="form_label" htmlFor="signup-business-name">Business Name</label>
                                        <div className="input_group_wrapper">
                                            <div className="input_group">
                                                <div className="icon_wrapper">
                                                    <span className="material-symbols-outlined">account_circle</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="businessname"
                                                    value={formData?.businessname}
                                                    onChange={handleChange}
                                                    placeholder="Business Name"
                                                    id="signup-business-name"
                                                />
                                                {error && <span className="errormsg" id="signup-businessname-error">{error?.businessname}</span>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form_label" htmlFor="locationSearchInput">Business Address</label>
                                        <div className="input-group mb-3 mr-sm-2">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text">
                                                    <span className="material-symbols-outlined">location_on</span>
                                                </div>
                                            </div>
                                            {/* Rendered even without a maps key: LocationSearch falls
                                                back to manual entry so signup is never blocked. */}
                                            <LocationSearch
                                                setSelectedPlace={(place) => {
                                                    setSelectedPlace(place);
                                                    handleAddressChange(addressData);
                                                }}
                                                setAddressData={(data) => {
                                                    setAddressData(data);
                                                    handleAddressChange(data);
                                                }}
                                                formData={formData}
                                                onBlur={() => handleAddressChange({ fullAddress: formData?.businessaddress })}
                                                selectedPlace={formData?.businessaddress}
                                                mapsAPIkey={mapsAPIkey}
                                                placeholder="Search for your business address"
                                            />
                                            {error && (
                                                <span className="errormsg" id="signup-businessaddress-error" style={{ fontWeight: 'bold', color: 'red' }}>
                                                    {error?.businessaddress}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <label className="form_label" htmlFor="signup-contact-name">Your Contact Info</label>

                                    <div className="col-md-6">
                                        <div className="input_group_wrapper">
                                            <div className="input_group">
                                                <div className="icon_wrapper">
                                                    <span className="material-symbols-outlined">person_outline</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="contactname"
                                                    value={formData?.contactname}
                                                    onChange={handleChange}
                                                    placeholder="Contact Name"
                                                    id="signup-contact-name"
                                                />
                                                {error && <span className="errormsg" id="signup-contactname-error">{error?.contactname}</span>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-group mb-3 mr-sm-2">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text">
                                                    <span className="material-symbols-outlined">call</span>
                                                </div>
                                            </div>

                                            <select
                                                name="idc"
                                                className="colorselect capitalize"
                                                onChange={handleCountryChange}
                                                value={formData?.idc}
                                                id="signup-country-code"
                                            >
                                                {countries && countries?.map((task, i) => (
                                                    <option key={i} value={task.alpha3}>
                                                        {task.alpha3}{task.countrycode}
                                                    </option>
                                                ))}
                                            </select>

                                            <input
                                                type="text"
                                                className="form-control"
                                                name="phone"
                                                id="signup-phone"
                                                value={formData?.phone}
                                                onChange={handleChange}
                                                placeholder="Phone Number"
                                            />
                                            {error && (
                                                <span className="errormsg" id="signup-phone-error" style={{ fontWeight: 'bold', color: 'red' }}>
                                                    {error?.phone}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input_group_wrapper mt-2">
                                            <div className="input_group">
                                                <div className="icon_wrapper">
                                                    <span className="material-symbols-outlined">mail</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="emailId"
                                                    value={formData?.emailId}
                                                    onChange={handleChange}
                                                    placeholder="Email"
                                                    id="signup-email"
                                                />
                                                {error && <span className="errormsg" id="signup-email-error">{error?.emailId}</span>}
                                            </div>
                                        </div>

                                        <div>
                                            <label className="form_label mt-4" htmlFor="signup-logo-upload">UPLOAD LOGO (optional)</label>
                                            <div className="upload-zone input-group mb-2 mr-sm-2">
                                                {formData?.logo?.length > 0 ? (
                                                    <div className="upload-icon mt-1">
                                                        <div className="img_block add_img_block">
                                                            <span className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove} onKeyDown={keyActivate(handleRemove)}>close</span>
                                                            <img src={formData.logo[0].filepath} id="signup-logo-preview" />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div>
                                                            <input
                                                                type="file"
                                                                id="signup-logo-upload"
                                                                accept="image/jpeg, image/png,image/heic,image/jpg"
                                                                className="d-none"
                                                                multiple={false}
                                                                onChange={handleFileChange}
                                                                style={{ display: 'none' }}
                                                            />
                                                            <label htmlFor="signup-logo-upload" className="stroke-button">
                                                                <span className="material-icons">file_upload</span>
                                                            </label>
                                                        </div>
                                                        <div className="file_requirements">
                                                            <p>Maximum file size: 5MB</p>
                                                            <p>Supported formats: JPG, PNG, HEIC</p>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                    </div>

                                    <div className="col-md-6 signup_illustration">
                                        <img
                                            src={`${image}${appname}/images/web/client-details-img.svg`}
                                            className="client-login-img"
                                            id="signup-side-image"
                                        />
                                    </div>
                                </div>

                                <div className="signup_footer">
                                    <div className="terms-block">
                                        <input
                                            type="checkbox"
                                            id="signup-terms"
                                            checked={termsAccepted}
                                            onChange={(e) => {
                                                setTermsAccepted(e.target.checked);
                                                setError((prevData) => ({ ...prevData, terms: "" }));
                                            }}
                                        />
                                        <label htmlFor="signup-terms">
                                            I agree to the{" "}
                                            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" id="signup-terms-link">Terms and Conditions</a>
                                            {" "}and{" "}
                                            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" id="signup-privacy-link">Privacy Policy</a>.
                                        </label>
                                    </div>
                                    {error?.terms && <span className="errormsg" id="signup-terms-error">{error.terms}</span>}

                                    <div className="signup_submit">
                                        <button
                                            className="fill-btn save_continue"
                                            id="signup-save-continue"
                                            onClick={handleVerify}
                                            disabled={BtnLoader}
                                        >
                                            {BtnLoader && (
                                                <img
                                                    src={`${image}${appname}/images/web/rotate_right.svg`}
                                                    className="loading-icon"
                                                />
                                            )}
                                            Save & Continue
                                        </button>
                                        <p className="signup_next_step" id="signup-next-step">
                                            <span className="material-symbols-outlined" aria-hidden="true">schedule</span>
                                            Once you submit it, a member of our team will reach out to approve your account.
                                        </p>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <SweetAlert show={exist}
                            custom
                            confirmBtnText="ok"
                            confirmBtnBsStyle="primary"
                            title={"Business Already Exists"}
                            onConfirm={e => setExist(false)}
                        />

                        <Modal className="access-denied" show={sendEmail}>
                            <div className="modal-body enquiry-form" id="otp-modal-body">
                                <div className="container" id="otp-container">

                                    <button
                                        className="close-btn"
                                        id="otp-close-button"
                                        onClick={e => handleClose()}
                                    >
                                        <span className="material-icons">close</span>
                                    </button>

                                    <span className="material-icons access-denied-icon" id="otp-icon">
                                        web_asset_off
                                    </span>

                                    <h3 id="otp-heading">OTP Verification</h3>
                                    <p id="otp-description">
                                        Click here to receive the OTP and continue your verification.
                                    </p>

                                    <div className="popup-footer" id="otp-footer">
                                        <button
                                            id="otp-verify-button"
                                            className="fill-btn mt-3"
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                console.log("Button clicked, calling handleSend...");
                                                handleSend();
                                            }}
                                        >
                                            {verifyLoader ? (
                                                <img
                                                    src={`${image}${appname}/images/web/rotate_right.svg`}
                                                    className="loading-icon"
                                                    alt="Loading"
                                                    id="otp-loader-icon"
                                                />
                                            ) : null}
                                            Verify
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        <SweetAlert show={alertMsg}
                            custom
                            confirmBtnText="ok"
                            confirmBtnBsStyle="primary"
                            title={"Please Wait For Admin Approval"}
                            onConfirm={e => setAlertMsg(false)}

                        />

                    </div>
                </div>
            </div>
            <footer className="login_footer">
                <div className="container-fluid">
                    <p className="footer-para">© {new Date().getFullYear()} SpotSaver. All rights reserved. </p>
                </div>

            </footer>


            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
                id="signup-toastContainer"
            />
        </>
    );
};

export default SignUp;
